/**
 * Custom Screens Registry
 * 
 * Organize custom screens by client/subdomain:
 *   Custom/
 *     caperoots/
 *       Home.tsx
 *     [another-client]/
 *       Home.tsx
 *       Gallery.tsx
 * 
 * Each screenKey in the database maps to a component here.
 * The `route` field in the database controls the URL path (e.g., 'home' -> /home)
 */

// Import custom screens from client folders
import { CapeRootsHome } from './caperoots/Home';
import { CapeRootsRestaurants } from './caperoots/Restaurants';

// Re-export for backward compatibility
export { CapeRootsHome, CapeRootsRestaurants };

// Registry: Maps screenKey -> Component
// Add new custom screens here when you create them
export const CustomScreenRegistry: Record<string, React.ComponentType<any>> = {
    // Cape Roots screens
    CapeRootsHome: CapeRootsHome,
    CapeRootsRestaurants: CapeRootsRestaurants,
    
    // Add more client screens here:
    // AnotherClientHome: AnotherClientHome,
    // AnotherClientGallery: AnotherClientGallery,
};

// Helper to get a custom screen component by screenKey
export const getCustomScreenComponent = (screenKey: string): React.ComponentType<any> | undefined => {
    return CustomScreenRegistry[screenKey];
};
